import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import Slideone from '../../assets/images/main-slider/slider-1.jpg';
import Slidetwo from '../../assets/images/main-slider/slider-2.jpg';
import Slidethree from '../../assets/images/main-slider/slider-3.jpg';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

function Banner() {
    return (
        <Swiper
            className="banner-section banner-section-coustm"
            loop={true}
            spaceBetween={0}
            slidesPerView={1}
            modules={[Navigation]}
            navigation={{ nextEl: '.swiper-button-next-c', prevEl: '.swiper-button-prev-c' }}
        >
            {/* Removed wrapper divs that conflict with Swiper React structure */}
            {[Slideone, Slidetwo, Slidethree].map((image, index) => (
                <SwiperSlide key={index} className="slide-item" style={{ backgroundImage: `url(${image})` }}>
                    <div className="overlay" style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1
                    }}></div>
                    <div className="auto-container" style={{ position: 'relative', zIndex: 2 }}>
                        <div className="content-box">
                            <div className="content">
                                <div className="clearfix">
                                    <div className="inner">
                                        <div className="subtitle">
                                            <span>nezaboravan ukus</span>
                                        </div>
                                        <div className="pattern-image">
                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                        </div>
                                        <h1><span>{index === 0 ? 'Autentični' : index === 1 ? 'Sveži' : 'Pripremljeno'}<br />{index === 0 ? 'Ukusi' : index === 1 ? 'Sastojci' : 'Sa Pažnjom'}</span></h1>
                                        <div className="text">Dođite sa porodicom i uživajte u svakom zalogaju</div>
                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                            <div className="link">
                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                    <span className="btn-wrap">
                                                        <span className="text-one">pogledajte naš meni</span>
                                                        <span className="text-two">pogledajte naš meni</span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
            <div className="swiper-button-prev-c">
                <span className="fal fa-angle-left"></span>
            </div>
            <div className="swiper-button-next-c">
                <span className="fal fa-angle-right"></span>
            </div>
            {/* <div className="book-btn">
                <Link to="#" className="theme-btn">
                    <span className="icon">
                        <img src={bookicon1} alt="" title="" />
                    </span>
                    <span className="txt">book a table</span>
                </Link>
            </div> */}
        </Swiper>
    );
}

export default Banner;
